const SERVICE_RATES = Object.freeze({"replies":15,"comments":15,"invitations":25,"profiles":79,"insights":99,"monitoring":49});

export function estimatePackage(selection) {
  if (!Array.isArray(selection) || selection.length === 0) return { state: 'empty', total: null, aboveRange: false };
  const seen = new Set();
  let total = 0;
  for (const item of selection) {
    const quantity = typeof item?.quantity === 'number' ? item.quantity : Number(item?.quantity);
    if (!item || !Object.hasOwn(SERVICE_RATES, item.id) || seen.has(item.id) || !Number.isInteger(quantity) || quantity < 1 || quantity > 1000) {
      return { state: 'invalid', total: null, aboveRange: false };
    }
    seen.add(item.id);
    total += SERVICE_RATES[item.id] * quantity;
  }
  return { state: 'ready', total, displayTotal: Math.min(total, 10000), aboveRange: total > 10000 };
}

function mountBuilder(root) {
  if (root.dataset.builderMounted) return;
  root.dataset.builderMounted = 'true';
  const feedback = root.querySelector('[data-builder-feedback]');
  if (feedback) feedback.focus();
  const form = root.querySelector('form');
  const cards = [...root.querySelectorAll('[data-builder-service]')];
  if (!form || !cards.length) return;
  const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  const total = root.querySelector('[data-builder-total]');
  const currency = root.querySelector('[data-builder-currency]');
  const breakdown = root.querySelector('[data-builder-breakdown]');
  const emptyError = root.querySelector('#builder-selection-error');
  const estimateField = root.querySelector('[data-builder-estimate-field]');
  const scopeField = root.querySelector('[data-builder-scope-field]');
  const submit = root.querySelector('[data-builder-submit]');
  const submitLabel = root.querySelector('[data-builder-submit-label]');
  const copy = key => root.querySelector(`[data-builder-copy-${key}]`).textContent;
  const model = cards.map(card => ({
    card,
    checkbox: card.querySelector('[data-service-choice]'),
    input: card.querySelector('[data-service-quantity]'),
    quantityWrap: card.querySelector('[data-service-quantity-wrap]'),
    title: card.querySelector('[data-service-title]').textContent,
    unit: card.querySelector('[data-service-unit]').textContent
  }));

  function refresh() {
    const selected = model.filter(item => item.checkbox.checked);
    const estimate = estimatePackage(selected.map(item => ({ id: item.checkbox.value, quantity: item.input.value })));
    for (const item of model) {
      item.quantityWrap.hidden = !item.checkbox.checked;
      item.input.disabled = !item.checkbox.checked;
    }
    model[0].checkbox.setCustomValidity(selected.length ? '' : copy('selection'));
    emptyError.hidden = selected.length > 0;
    root.querySelector('[data-builder-invalid]').hidden = estimate.state !== 'invalid';
    root.querySelector('[data-builder-limit]').hidden = !estimate.aboveRange;
    currency.hidden = estimate.state !== 'ready';
    total.classList.toggle('ts-builder__estimate--message', estimate.state !== 'ready');
    total.textContent = estimate.state === 'ready' ? format.format(estimate.displayTotal) + (estimate.aboveRange ? '+' : '') : copy(estimate.state === 'empty' ? 'empty' : 'invalid');
    root.querySelector('[data-builder-mobile-total]').textContent = total.textContent;
    breakdown.replaceChildren();
    const scope = [];
    for (const item of selected) {
      const valid = item.input.validity.valid;
      const line = document.createElement('li');
      const description = document.createElement('span');
      const amount = document.createElement('strong');
      const quantity = valid ? Number(item.input.value) : '—';
      description.textContent = `${item.title} × ${quantity}`;
      amount.textContent = valid ? format.format(SERVICE_RATES[item.checkbox.value] * Number(item.input.value)) : '—';
      line.append(description, amount);
      breakdown.append(line);
      scope.push(`${item.title}: ${quantity} ${item.unit}; indicative unit fee ${format.format(SERVICE_RATES[item.checkbox.value])}`);
    }
    const estimateText = estimate.state === 'ready' ? total.textContent + ' EUR; indicative only, not a quote or order' + (estimate.aboveRange ? '; scope exceeds the estimator range and requires an individual quote' : '') : 'No valid estimate; personal quote required';
    estimateField.value = estimateText;
    scopeField.value = scope.join('\n');
    return estimate;
  }

  root.addEventListener('input', event => {
    if (event.target.matches('[data-service-quantity]')) refresh();
  });
  root.addEventListener('change', event => {
    if (event.target.matches('[data-service-choice]')) refresh();
  });
  form.addEventListener('submit', event => {
    const estimate = refresh();
    if (estimate.state !== 'ready' || !form.reportValidity()) {
      event.preventDefault();
      if (!model.some(item => item.checkbox.checked)) model[0].checkbox.focus();
      return;
    }
    submit.setAttribute('aria-busy', 'true');
    submitLabel.textContent = copy('sending');
    root.querySelector('[data-builder-sending]').hidden = false;
  });
  window.addEventListener('pageshow', () => {
    submit.removeAttribute('aria-busy');
    submitLabel.textContent = copy('contact');
    root.querySelector('[data-builder-sending]').hidden = true;
    refresh();
  });
  refresh();
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-package-builder]').forEach(mountBuilder);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-package-builder]').forEach(mountBuilder));
}
